// Idle sign-out (backend idle_logout.py). Off unless the workspace turns it
// on; then the server sends `idle_logout_minutes` with sign-in and /me.
// Activity is the person's own clicks, keys, touches and scrolling - never a
// background poll - recorded in localStorage so every open tab shares it.
export const LAST_ACTIVITY_KEY = 'hrms.lastActivity';
const EVENTS = ['mousedown', 'keydown', 'touchstart', 'wheel', 'scroll', 'mousemove'];
const WRITE_EVERY_MS = 15000;
const CHECK_EVERY_MS = 30000;

const read = () => {
  try { return Number(window.localStorage.getItem(LAST_ACTIVITY_KEY)) || 0; } catch { return 0; }
};
const write = (at) => {
  try { window.localStorage.setItem(LAST_ACTIVITY_KEY, String(at)); } catch { /* private mode: this tab only */ }
};

/** A fresh sign-in starts the clock, so an old tab's timestamp can't end it. */
export const markActive = (now = Date.now()) => write(now);

export const isIdle = (last, minutes, now = Date.now()) => Boolean(minutes && last && now - last > minutes * 60000);

/** Watches for activity; calls `onIdle` once when `minutes` pass without any. Returns a stop function. */
export const watchIdle = (minutes, onIdle) => {
  if (!minutes) return () => {};
  if (!read()) markActive();
  let lastWrite = 0;
  let fired = false;
  const onActivity = () => {
    const now = Date.now();
    if (now - lastWrite > WRITE_EVERY_MS) { lastWrite = now; write(now); }
  };
  const check = () => {
    if (!fired && isIdle(read(), minutes)) { fired = true; onIdle(); }
  };
  EVENTS.forEach((e) => window.addEventListener(e, onActivity, { passive: true }));
  const timer = setInterval(check, CHECK_EVERY_MS);
  check(); // a tab reopened after hours is already past it
  return () => {
    EVENTS.forEach((e) => window.removeEventListener(e, onActivity));
    clearInterval(timer);
  };
};
